import React, { useEffect, useState, useRef } from "react";
import Table from "./Table";
import { useHistory } from "react-router-dom";
import { formatNumber, handleState } from "../../Utils/utils";
import Flags from "./Flags";
import Tooltips from "./Tooltips";
import IconReport from "../../Resources/svg/Icons/IconReport";
import { useDispatch } from "react-redux";
import { alert, stateAlert } from "../../Store/simulate/actions";
import IconDownload from "../../Resources/svg/Icons/IconDownload";
import ModalConfirmation from "../modalConfirmation";
import ModalLog from "../modalLog";
import CardTablaRV from "./CardTablaRV";
import { meses } from "../../Utils/aprobaciones/month";
import ModalAnulacionRV from "../modalAnulacionRV";
import { anularOperacionRV } from "../../Services/RVAnulacionService";
import IconDelete from "../../Resources/svg/Icons/IconDelete";

const itemsLog = [
  {
    modalidad: "modalidad1",
    moneda: "DNI",
    fecProcesamiento: "08/09/2010",
    state: "estado",
    motivoError: "motivo",
  },
  {
    modalidad: "modalidad2",
    moneda: "DNI",
    fecProcesamiento: "08/09/2011",
    state: "estado",
    motivoError: "motivo",
  },
  {
    modalidad: "modalidad3",
    moneda: "DNI",
    fecProcesamiento: "08/09/2012",
    state: "estado",
    motivoError: "motivo",
  },
];

const TableQuotesRV = ({
  data,
  setIsLoading,
  getQuotes,
  setSelectedQuotes,
  selectedQuotes,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [itemsList, setItemList] = useState([...data]);
  const [activeAllButon, setActiveAllButton] = useState(false);
  const [stateLog, setStateLog] = useState({ items: {}, openTableLog: false });
  const { items, openTableLog } = stateLog;
  const [openModalConfirmLogQuote, setOpenModalConfirmLogQuote] =
    useState(false);
  const elem = useRef(null);
  const [openModalConfirmQuote, setOpenModalConfirmQuote] = useState(false);
  const [quoteSelected, setQuoteSelected] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [linkPdf, setLinkPdf] = useState("");
  const stateAvailables = ["mejorado", "cotizado", "enviadoMeller"];
  const [closeDateValidation, setCloseDateValidation] = useState(false);
  const [openModalAnulacion, setOpenModalAnulacion] = useState(false);
  const [operacionToAnular, setOperacionToAnular] = useState(null);

  const goToDetail = (item) => {
    history.push({
      pathname: "/cotizaciones/detalle",
      state: item,
    });
  };

  const goToModalities = (item) => {
    history.push({
      pathname: "/cotizaciones/detalle-modalidades",
      state: item,
    });
  };

  const setAlert = (type, title, message) => {
    dispatch(stateAlert(true));
    dispatch(
      alert({
        type,
        title,
        message,
      })
    );

    setTimeout(() => {
      dispatch(stateAlert(false));
    }, 4000);
  };

  const openModalLog = () =>
    setStateLog((prevState) => ({ ...prevState, openTableLog: true }));
  const onCloseModalLog = () =>
    setStateLog((prevState) => ({ ...prevState, openTableLog: false }));

  const handleOnChange = (e, item) => {
    setActiveAllButton(false);
    const { name } = e.target;
    const arrayName = name.split("_");
    const position = arrayName[1];
    const newData = itemsList;

    newData[position].active = !newData[position].active;
    if (newData[position].active) {
      setSelectedQuotes([
        ...selectedQuotes,
        { id: newData[position].nroOperacion },
      ]);
    } else {
      const filterSelectedQuotes = selectedQuotes.filter(
        (element) => element.id !== newData[position].nroOperacion
      );
      setSelectedQuotes([...filterSelectedQuotes]);
    }

    setItemList([...newData]);

    if (newData[position].active) {
      setSelectedItems([...selectedItems, newData[position]]);
    } else {
      setSelectedItems(selectedItems.filter((i) => i !== newData[position]));
    }
  };

  const handleSelectAllIems = (e) => {
    setActiveAllButton(e.target.checked);
    let data = [...itemsList];
    data.forEach((item) => {
      if (stateAvailables.includes(item.estado)) {
        item.active = e.target.checked;
        return item;
      }
    });
    setItemList([...data]);

    if (e.target.checked) {
      setSelectedItems([...data]);
      setSelectedQuotes([...data]);
    } else {
      setSelectedItems([]);
      setSelectedQuotes([]);
    }
  };

  const availableButtons = (item) => {
    const actions = {
      quote: false,
      pdf: false,
      log: false,
    };

    switch (item.estado) {
      case "cotizado":
      case "mejorado":
      case "enviadoMeller":
      case "ganado":
      case "perdido":
      case "recalculado":
      case "emitida":
      case "cartaEnviada":
      case "datosActualizados":
      case "enviadoEmision":
        actions.pdf = true;
        break;
      case "ingresadoRp":
        actions.quote = true;
        break;
      case "errorCotizacion":
        actions.log = true;
        break;
      case "anulado":
        break;
      default:
        break;
    }

    return actions;
  };

  const confirmToQuote = (item) => {
    setOpenModalConfirmQuote(true);
    setQuoteSelected(item);
  };

  const quoteRequest = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setAlert(
        "success",
        "Cotización exitosa!",
        "Se ha realizado la cotización."
      );
      setIsLoading(false);
      getQuotes();
    }, 2000);
  };

  const quoteLogRequest = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setAlert(
        "success",
        "Recotización exitosa!",
        "Se ha realizado la cotización."
      );
      onCloseModalLog();
      setIsLoading(false);
    }, 2000);
  };

  const generatePdfQuote = async (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setAlert("success", "¡Listo, descarga completa!", "");
      setIsLoading(false);
    }, 2000);
  };

  const logRequest = (item) => {
    openModalLog();
    setQuoteSelected(item);
  };

  const handleAnularOperacion = (item) => {
    setOperacionToAnular(item.nroOperacion);
    setOpenModalAnulacion(true);
  };

  const handleSubmitAnulacion = async (payload) => {
    try {
      setIsLoading(true);
      await anularOperacionRV(payload);
      setAlert(
        "success",
        "Anulación exitosa!",
        "La operación ha sido anulada correctamente."
      );
      getQuotes();
    } catch (error) {
      setAlert(
        "error",
        "Error en anulación",
        "No se pudo anular la operación. Intente nuevamente."
      );
    } finally {
      setIsLoading(false);
      setOpenModalAnulacion(false);
      setOperacionToAnular(null);
    }
  };

  useEffect(() => {}, [selectedItems.length]);

  useEffect(() => {
    return () => {
      let data = [...itemsList];
      data.forEach((item) => {
        item.active = false;
        return item;
      });
      setItemList([...data]);
    };
  }, []);

  useEffect(() => {
    const validateCloseDate = data.every(
      (item, _, arr) => item.fechaCierre === arr[0].fechaCierre
    );
    setCloseDateValidation(validateCloseDate);
  }, [itemsList]);

  useEffect(() => {
    if (linkPdf) {
      elem.current.click();
    }
  }, [linkPdf]);

  return (
    <>
      <div className="table-box">
        <a
          style={{ display: "none" }}
          target="_blank"
          rel="noopener noreferrer"
        />
        <Table>
          <thead>
            <tr>
              <th>
                {closeDateValidation && (
                  <div className="column-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="isCheckLegal"
                        className="filled-in"
                        checked={activeAllButon}
                        onChange={(e) => handleSelectAllIems(e)}
                      />
                      <span></span>
                    </label>
                  </div>
                )}
              </th>
              <th width="96px">N° DE OPERACIÓN</th>
              <th>CUSPP</th>
              <th>DNI / CE</th>
              <th width="130" style={{ minWidth: "120px" }}>
                FECHA CARGA
              </th>
              <th width="130" style={{ minWidth: "120px" }}>
                FECHA CIERRE
              </th>
              <th width="130" style={{ minWidth: "120px" }}>
                NRO. DE Póliza
              </th>
              <th width="130" style={{ minWidth: "120px" }}>
                CAPITAL PENSIÓN
              </th>
              <th width="180" style={{ minWidth: "155px" }}>
                ESTADO
              </th>
              <th>ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            {itemsList.length > 0 &&
              itemsList.map((item, index) => (
                <tr key={index}>
                  <td>
                    {closeDateValidation && (
                      <div className="column-checkbox">
                        <label>
                          <input
                            type="checkbox"
                            name={`checkbox_${index}`}
                            className="filled-in"
                            checked={item.active}
                            disabled={!stateAvailables.includes(item.estado)}
                            onChange={(event) => handleOnChange(event, item)}
                          />
                          <span></span>
                        </label>
                      </div>
                    )}
                  </td>
                  <td>{item.nroOperacion}</td>
                  <td>{item.CUSPP}</td>
                  <td>{item.afiliado.nroDoc}</td>
                  <td>
                    {item.fechaCargaXML.split("-")[2]}{" "}
                    {
                      meses[
                        item.fechaCargaXML
                          ? item.fechaCargaXML.split("-")[1] - 1
                          : "-"
                      ]
                    }{" "}
                    {item.fechaCargaXML.split("-")[0]
                      ? item.fechaCargaXML.split("-")[0]
                      : "-"}
                  </td>
                  <td>
                    {item.fechaCierre.split("-")[2]}{" "}
                    {
                      meses[
                        item.fechaCierre
                          ? item.fechaCierre.split("-")[1] - 1
                          : "-"
                      ]
                    }{" "}
                    {item.fechaCierre.split("-")[0]
                      ? item.fechaCierre.split("-")[0]
                      : "-"}
                  </td>
                  <td>
                    {item.datosEmision ? item.datosEmision.numPoliza : "--"}
                  </td>
                  <td>{`${item.fondo.moneda} ${formatNumber.new(item.fondo.capitalPension)}`}</td>
                  <td>
                    <div className="flag-state-info">
                      <Flags
                        variant={item.estado}
                        widthreprom={item.necesitaRemuneracionPromedio}
                      >
                        {handleState(
                          item.estado,
                          item.necesitaRemuneracionPromedio
                        )}
                      </Flags>
                      {item.descripcionEstado && (
                        <Tooltips text={item.descripcionEstado} />
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="action-container">
                      {availableButtons(item).log && (
                        <div
                          className="action-container__btn"
                          onClick={() => logRequest(item)}
                        >
                          <span>Log</span>
                        </div>
                      )}
                      {availableButtons(item).pdf && item.respuestaECM && (
                        <>
                          {item.respuestaECM.cartaAFP &&
                            [
                              "emitida",
                              "cartaEnviada",
                              "datosActualizados",
                              "enviadoEmision",
                              "recalculado",
                            ].includes(item.estado) && (
                              <div
                                className="action-container__item"
                                onClick={() =>
                                  window.open(
                                    item.respuestaECM.cartaAFP.documents
                                      .fileUrl,
                                    "_blank"
                                  )
                                }
                              >
                                <IconDownload />
                                <span>Mostrar Carta AFP</span>
                              </div>
                            )}
                          <div
                            className="action-container__item"
                            onClick={() =>
                              window.open(
                                item.respuestaECM.cotizacion.documents.fileUrl,
                                "_blank"
                              )
                            }
                          >
                            <IconDownload />
                            <span>Descargar</span>
                          </div>
                        </>
                      )}
                      <div
                        className="action-container__item"
                        onClick={() => goToDetail(item)}
                      >
                        <IconReport />
                        <span>Detalle</span>
                      </div>
                      {!["emitida", "recalculado", "ganado", "anulado"].includes(
                        item.estado
                      ) && (
                        <div
                          className="action-container__item"
                          onClick={() => handleAnularOperacion(item)}
                        >
                          <IconDelete />
                          <span>Anular</span>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
      {data.map((datos, index) => (
        <CardTablaRV
          data={datos}
          key={index}
          confirmToQuote={confirmToQuote}
          logRequest={logRequest}
          generatePdfQuote={generatePdfQuote}
          goToDetail={goToDetail}
          goToModalities={goToModalities}
          checkboxActive={datos.active}
          itemIndex={index}
          handleOnChange={(event) => handleOnChange(event, datos)}
        />
      ))}
      <ModalConfirmation
        open={openModalConfirmQuote}
        setOpen={setOpenModalConfirmQuote}
        title={"¿Estás seguro de cotizar?"}
        message={`Se procederá a cotizar la solicitud seleccionada con CUSPP ${quoteSelected.CUSPP}.`}
        acceptCallback={() => quoteRequest(quoteSelected)}
      />
      <ModalLog
        open={openTableLog}
        onCloseModal={onCloseModalLog}
        items={itemsLog}
        CUSPP={quoteSelected.CUSPP}
        setOpenModalConfirmLogQuote={setOpenModalConfirmLogQuote}
        setQuoteSelected={setQuoteSelected}
      />
      <ModalConfirmation
        open={openModalConfirmLogQuote}
        setOpen={setOpenModalConfirmLogQuote}
        title={"¿Estás seguro de cotizar?"}
        message={`Se procederá a cotizar la solicitud.`}
        acceptCallback={() => quoteLogRequest(quoteSelected)}
      />
      <ModalAnulacionRV
        open={openModalAnulacion}
        setOpen={setOpenModalAnulacion}
        nroOperacion={operacionToAnular}
        onSubmitCallback={handleSubmitAnulacion}
      />
    </>
  );
};

export default TableQuotesRV;
